import { canvasManager } from "appworks/graphics/canvas/canvas-manager";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { UIFlag, uiFlags, UIMenuFlag } from "appworks/ui/flags/ui-flags";
import { deviceInfo } from "appworks/utils/device-info";
import { Point } from "appworks/utils/geom/point";
import { PartnerConnectEvents, YggUiSpace } from "partner-connect/partner-connect-events";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { slotModel } from "slotworks/model/slot-model";

export function TGRSetupPartnerConnect() {
    PartnerConnectEvents.onShowRules.add(() => {
        uiFlags.menu(UIMenuFlag.RULES, true);
    });

    window.addEventListener("message", (event: MessageEvent) => {
        if (event.data === "gameRound/end") {
            const prepaidData = PartnerConnectManager.prepaidData;

            if (prepaidData?.state?.bet?.amount) {
                slotModel.write({ bet: Services.bet.getCreditsForTotalStake(prepaidData.state.bet.amount * 100, false) });
            }
            if (prepaidData?.collect) {
                if (Services.autoplay.isAutoPlaying()) {
                    Services.autoplay.stop();
                }
            }
            if (uiFlags.has(UIFlag.FREE_BETS)) {
                if (!prepaidData || (prepaidData?.collect && !prepaidData?.state)) {
                    slotModel.write({ bet: Services.bet.getCreditsForTotalStake(slotModel.read().bet.creditSizes.defaultValue, false) });
                    uiFlags.set(UIFlag.FREE_BETS, false);
                    gameState.autoDeductStake = true;
                    if (Services.autoplay.isAutoPlaying()) {
                        Services.autoplay.stop();
                    }
                }
            }
        } else if (event.data === "balance/changed") {
            PartnerConnectManager.getEmitters().balanceChanged(event.data.data);
        }
    });

    PartnerConnectEvents.onUiChanged.add((els: any[]) => {
        const prepaidInfo = PartnerConnectManager.getGame().getWagerHelper().getPrepaidInfo();
        if (prepaidInfo.isPrepaid) {
            els.forEach((el: any) => {
                if (el.id === "boost/top-bar") {
                    slotModel.write({ bet: Services.bet.getCreditsForTotalStake(prepaidInfo.betValue * 100, false) });
                }
            });
        }
    });
    PartnerConnectEvents.onYggUiChanged.add((yggUiSpace: YggUiSpace) => {
        rescaleForYggUI();
    });

    if (deviceInfo.isIE11()) {
        window.onresize = () => rescaleForYggUI();
    }
    window.addEventListener("resize", () => rescaleForYggUI());
    window.addEventListener("load", () => rescaleForYggUI());
    window.addEventListener("orientationchange", () => rescaleForYggUI());
    rescaleForYggUI();
}

function rescaleForYggUI(): void {
    if (canvasManager.canvas && PartnerConnectEvents.yggUiSpace) {
        if (PartnerConnectEvents.yggUiSpace.top || PartnerConnectEvents.yggUiSpace.bottom || PartnerConnectEvents.yggUiSpace.left || PartnerConnectEvents.yggUiSpace.right) {
            const availWidth: number = window.innerWidth - PartnerConnectEvents.yggUiSpace.left - PartnerConnectEvents.yggUiSpace.right;
            const availHeight: number = window.innerHeight - PartnerConnectEvents.yggUiSpace.top - PartnerConnectEvents.yggUiSpace.bottom;
            const idealScaleW: number = availWidth / window.innerWidth;
            const idealScaleH: number = availHeight / window.innerHeight;
            const scale = Math.min(idealScaleW, idealScaleH);
            const offsetX: number = PartnerConnectEvents.yggUiSpace.left / availWidth / 2;
            const offsetY: number = PartnerConnectEvents.yggUiSpace.top / availHeight / 2;
            const anchor: Point = new Point(0.5);
            const offset: Point = new Point(offsetX, offsetY);
            canvasManager.setLandscapeScale(scale, anchor, offset);
        } else {
            canvasManager.setLandscapeScale(1, new Point(0.5), new Point(0));
        }
    }
}
